var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4bb82f}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm0 18.75a6.87 6.87 0 0 1-3.26-.83l-3.61.95 1-3.53a6.74 6.74 0 0 1-.91-3.4A6.82 6.82 0 0 1 12 5.13a6.83 6.83 0 0 1 6.81 6.81A6.82 6.82 0 0 1 12 18.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12 6.28A5.66 5.66 0 0 0 7.24 15l.13.21-.57 2.04 2.14-.56.21.12a5.57 5.57 0 0 0 2.85.79 5.66 5.66 0 0 0 0-11.32zm3.33 8.09a1.74 1.74 0 0 1-1.15.81 2.38 2.38 0 0 1-1.07-.07 9.21 9.21 0 0 1-1-.36 7.6 7.6 0 0 1-2.91-2.56 3.42 3.42 0 0 1-.69-1.76A1.93 1.93 0 0 1 9.16 9a.64.64 0 0 1 .46-.21h.32c.11 0 .25 0 .39.29l.52 1.27a.32.32 0 0 1 0 .29 1.38 1.38 0 0 1-.17.29c-.09.1-.18.22-.26.29s-.17.18-.07.35a4.93 4.93 0 0 0 .94 1.18 4.47 4.47 0 0 0 1.37.84c.17.09.27.07.37 0s.42-.49.54-.67.22-.14.38-.08 1 .47 1.16.55.29.13.33.2a1.47 1.47 0 0 1-.08.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.54eb63fb0883dd401af3e42f91a1c919.svg";
export { ForwardRef as ReactComponent };